module.exports = __webpack_public_path__ + "static/media/eth.22ab34bf.svg";